/**
 * Eigene i18next-Instanz des Berichts — unabhängig von der Instanz der App.
 *
 * Der Bericht wird an zwei Stellen erzeugt: im Browser (Ansicht und
 * „Bericht kopieren") und auf dem Server (`renderBerichtMail`, MCP-Werkzeug
 * `statusbericht_als_mail`). Hinge er an der App-Instanz, gäbe es auf dem
 * Server keine Texte — und zwei Kopien der Schlüssel liefen irgendwann
 * auseinander. Deshalb wohnen die Berichtsschlüssel hier und nur hier
 * (`locales/de.json`, `locales/en.json`); die Sprachdateien der App führen
 * sie nicht mehr. Ausnahme: `pages.statusReports.left` und
 * `pages.statusReports.report.colNextSteps` braucht auch die
 * Bearbeitungsoberfläche, sie stehen deshalb in beiden.
 *
 * Die Sprache ist fest (`REPORT_LANGUAGE`, Fachkonzept §13.1): Der Bericht
 * richtet sich nach dem Kunden, nicht nach der Oberflächensprache des
 * Absenders. `en` liegt bei, damit die Erweiterung auf eine Sprache je
 * Beauftragung (docs/OFFENE-PUNKTE.md) nur noch den Aufruf ändert.
 */
import i18next, { type i18n as I18n } from "i18next";

import de from "./locales/de.json" with { type: "json" };
import en from "./locales/en.json" with { type: "json" };
import type { Translate } from "./mailDraft.js";
import { REPORT_LANGUAGE } from "./reportLanguage.js";

export const berichtI18n: I18n = i18next.createInstance();

// Synchron: Die Ressourcen liegen bei, es gibt nichts nachzuladen — und der
// Server rendert direkt nach dem Import.
void berichtI18n.init({
  resources: { de: { translation: de }, en: { translation: en } },
  lng: REPORT_LANGUAGE,
  fallbackLng: REPORT_LANGUAGE,
  interpolation: { escapeValue: false },
  initAsync: false,
});

/** Übersetzer für eine Berichtssprache (Vorgabe: `REPORT_LANGUAGE`). */
export function berichtTranslate(sprache: string = REPORT_LANGUAGE): Translate {
  const fixed = berichtI18n.getFixedT(sprache);
  return (key, opts) => fixed(key, opts) as string;
}

/** Der Übersetzer des kundengerichteten Teils. */
export const berichtT: Translate = berichtTranslate();
